export default __webpack_public_path__ + "static/media/correspondent5.4a1e7c16.png";